import React from 'react';

const BonzoCharacter = ({ width = 260, height = 310, style = {} }) => (
  <svg
    viewBox="0 0 260 330"
    width={width}
    height={height}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="bz_skin" cx="40%" cy="35%" r="60%">
        <stop offset="0%" stopColor="#f8c898" />
        <stop offset="100%" stopColor="#d48858" />
      </radialGradient>
      <radialGradient id="bz_head" cx="38%" cy="30%" r="65%">
        <stop offset="0%" stopColor="#f8c898" />
        <stop offset="60%" stopColor="#e2a870" />
        <stop offset="100%" stopColor="#c07848" />
      </radialGradient>
      <linearGradient id="bz_shirt" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#c8a055" />
        <stop offset="55%" stopColor="#a07830" />
        <stop offset="100%" stopColor="#785818" />
      </linearGradient>
      <linearGradient id="bz_shell" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#9a2c10" />
        <stop offset="55%" stopColor="#6a1c08" />
        <stop offset="100%" stopColor="#4a1006" />
      </linearGradient>
      <radialGradient id="bz_drumhead" cx="38%" cy="35%" r="65%">
        <stop offset="0%" stopColor="#f0e8d0" />
        <stop offset="80%" stopColor="#d4c0a0" />
        <stop offset="100%" stopColor="#b8a080" />
      </radialGradient>
      <radialGradient id="bz_cymbal" cx="35%" cy="28%" r="65%">
        <stop offset="0%" stopColor="#f8d848" />
        <stop offset="55%" stopColor="#d4a820" />
        <stop offset="100%" stopColor="#9a7210" />
      </radialGradient>
      <linearGradient id="bz_chrome" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#e8e8e8" />
        <stop offset="50%" stopColor="#b8b8b8" />
        <stop offset="100%" stopColor="#888888" />
      </linearGradient>
      <linearGradient id="bz_jeans" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#2e3e60" />
        <stop offset="100%" stopColor="#161e38" />
      </linearGradient>
      <filter id="bz_drop" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="2" dy="4" stdDeviation="3" floodOpacity="0.35" />
      </filter>
    </defs>

    {/* Ground shadow */}
    <ellipse cx="130" cy="325" rx="88" ry="8" fill="rgba(0,0,0,0.4)" />

    {/* ══ HI-HAT STAND (background, behind left arm) ══ */}
    <line x1="20" y1="288" x2="20" y2="322" stroke="#909090" strokeWidth="3" strokeLinecap="round" />
    <line x1="13" y1="296" x2="27" y2="296" stroke="#808080" strokeWidth="3" strokeLinecap="round" />
    <line x1="20" y1="228" x2="20" y2="290" stroke="#b0b0b0" strokeWidth="2" strokeLinecap="round" />
    {/* Hi-hat foot pedal */}
    <rect x="8" y="310" width="24" height="8" rx="2" fill="#606060" stroke="#404040" strokeWidth="1" />

    {/* ══ BASS DRUM ══ */}
    {/* Shell */}
    <ellipse cx="130" cy="292" rx="64" ry="26" fill="url(#bz_shell)" stroke="#2a0c04" strokeWidth="3" filter="url(#bz_drop)" />
    {/* Drumhead */}
    <ellipse cx="130" cy="285" rx="55" ry="20" fill="url(#bz_drumhead)" stroke="#9a7040" strokeWidth="2.5" />
    {/* Inner ring */}
    <ellipse cx="130" cy="285" rx="46" ry="15" fill="none" stroke="rgba(160,120,60,0.4)" strokeWidth="1.5" />
    {/* BONZO text on drum */}
    <text x="130" y="290" textAnchor="middle" fontSize="13" fill="rgba(90,40,15,0.65)"
      fontFamily="Georgia, serif" fontStyle="italic" fontWeight="bold">BONZO</text>
    {/* Tension rods */}
    {[...Array(8)].map((_, i) => {
      const a = (i * 45 - 90) * Math.PI / 180;
      const x = 130 + 61 * Math.cos(a);
      const y = 292 + 24 * Math.sin(a);
      return <circle key={i} cx={x} cy={y} r="2.5" fill="url(#bz_chrome)" stroke="#888" strokeWidth="0.8" />;
    })}
    {/* Rim */}
    <ellipse cx="130" cy="285" rx="58" ry="22" fill="none" stroke="url(#bz_chrome)" strokeWidth="3.5" />
    {/* Spur legs */}
    <line x1="82" y1="307" x2="70" y2="324" stroke="#707070" strokeWidth="3" strokeLinecap="round" />
    <line x1="178" y1="307" x2="190" y2="324" stroke="#707070" strokeWidth="3" strokeLinecap="round" />
    {/* Kick pedal */}
    <rect x="112" y="307" width="36" height="5" rx="2" fill="#505050" stroke="#383838" strokeWidth="1" />
    <rect x="120" y="310" width="20" height="14" rx="2" fill="#404040" />

    {/* ══ DRUM STOOL ══ */}
    <ellipse cx="130" cy="272" rx="22" ry="9" fill="#2a1e0e" stroke="#1a1006" strokeWidth="2" />
    <rect x="127" y="272" width="6" height="22" fill="#4a4a4a" />
    <ellipse cx="130" cy="295" rx="22" ry="5" fill="#303030" />

    {/* ══ LEGS (visible beside bass drum) ══ */}
    <path d="M 68 268 Q 66 280 68 298 Q 72 308 80 310 Q 90 307 88 296 Q 86 278 84 268 Z"
      fill="url(#bz_jeans)" stroke="#101828" strokeWidth="1.5" />
    <path d="M 176 268 Q 178 280 176 298 Q 172 308 164 310 Q 154 307 156 296 Q 158 278 160 268 Z"
      fill="url(#bz_jeans)" stroke="#101828" strokeWidth="1.5" />

    {/* ══ TORSO ══ */}
    <path d="M 70 182 Q 58 220 56 268 L 204 268 Q 202 220 190 182 Z"
      fill="url(#bz_shirt)" stroke="#6a4010" strokeWidth="2.5" filter="url(#bz_drop)" />
    {/* Shirt shadow */}
    <path d="M 70 182 Q 60 220 58 268 L 130 268 L 130 182 Z" fill="rgba(0,0,0,0.14)" />
    {/* Open collar V-neck */}
    <path d="M 104 178 L 86 210 L 130 220 L 174 210 L 156 178 Z" fill="#b89040" />
    <path d="M 128 178 L 110 216 L 130 222 L 150 216 L 132 178 Z" fill="#a07828" />
    {/* Chest hair detail */}
    <path d="M 116 210 Q 123 218 130 216 Q 137 218 144 210"
      fill="none" stroke="rgba(60,30,10,0.35)" strokeWidth="2" strokeLinecap="round" />
    {/* Belt */}
    <rect x="76" y="257" width="108" height="11" rx="1" fill="#4a3418" stroke="#2a1e08" strokeWidth="1.5" />
    <rect x="118" y="255" width="24" height="14" rx="2" fill="#c09020" stroke="#906010" strokeWidth="1.5" />
    <text x="130" y="265" textAnchor="middle" fontSize="5.5" fill="#604010" fontFamily="Arial" fontWeight="bold">LZ</text>

    {/* ══ TOM-TOMS (on bass drum) ══ */}
    {/* Left rack tom */}
    <ellipse cx="97" cy="252" rx="26" ry="11" fill="url(#bz_shell)" stroke="#2a0c04" strokeWidth="2" />
    <ellipse cx="97" cy="248" rx="22" ry="8.5" fill="url(#bz_drumhead)" stroke="#9a7040" strokeWidth="1.5" />
    {[0, 1, 2, 3].map(i => {
      const a = (i * 90) * Math.PI / 180;
      return <circle key={i} cx={97 + 24 * Math.cos(a)} cy={252 + 10 * Math.sin(a)} r="2" fill="url(#bz_chrome)" />;
    })}
    <line x1="97" y1="246" x2="112" y2="234" stroke="#606060" strokeWidth="2.5" strokeLinecap="round" />

    {/* Right rack tom */}
    <ellipse cx="163" cy="252" rx="26" ry="11" fill="url(#bz_shell)" stroke="#2a0c04" strokeWidth="2" />
    <ellipse cx="163" cy="248" rx="22" ry="8.5" fill="url(#bz_drumhead)" stroke="#9a7040" strokeWidth="1.5" />
    {[0, 1, 2, 3].map(i => {
      const a = (i * 90) * Math.PI / 180;
      return <circle key={i} cx={163 + 24 * Math.cos(a)} cy={252 + 10 * Math.sin(a)} r="2" fill="url(#bz_chrome)" />;
    })}
    <line x1="163" y1="246" x2="148" y2="234" stroke="#606060" strokeWidth="2.5" strokeLinecap="round" />

    {/* ══ LEFT ARM (toward snare/hi-hat) ══ */}
    <path d="M 78 194 Q 52 210 38 228 Q 28 242 26 258"
      fill="none" stroke="#6a4010" strokeWidth="22" strokeLinecap="round" opacity="0.4" />
    <path d="M 78 194 Q 52 210 38 228 Q 28 242 26 258"
      fill="none" stroke="url(#bz_shirt)" strokeWidth="18" strokeLinecap="round" />
    {/* Left wrist */}
    <ellipse cx="25" cy="260" rx="10" ry="8" fill="url(#bz_skin)" stroke="#c07838" strokeWidth="1.5"
      transform="rotate(12,25,260)" />

    {/* ══ RIGHT ARM (RAISED HIGH — power strike) ══ */}
    <path d="M 182 194 Q 208 178 224 156 Q 236 138 240 120"
      fill="none" stroke="#6a4010" strokeWidth="22" strokeLinecap="round" opacity="0.4" />
    <path d="M 182 194 Q 208 178 224 156 Q 236 138 240 120"
      fill="none" stroke="url(#bz_shirt)" strokeWidth="18" strokeLinecap="round" />
    {/* Right wrist */}
    <ellipse cx="241" cy="118" rx="10" ry="8" fill="url(#bz_skin)" stroke="#c07838" strokeWidth="1.5"
      transform="rotate(-22,241,118)" />

    {/* ══ NECK ══ */}
    <rect x="112" y="156" width="36" height="30" rx="13" fill="url(#bz_skin)" stroke="#b07038" strokeWidth="2.5" />
    <line x1="130" y1="158" x2="130" y2="183" stroke="rgba(160,90,40,0.18)" strokeWidth="1.5" />

    {/* ══ HEAD ══ */}
    <ellipse cx="130" cy="116" rx="52" ry="54" fill="url(#bz_head)" stroke="#111" strokeWidth="2.5"
      filter="url(#bz_drop)" />
    {/* Highlight */}
    <ellipse cx="112" cy="96" rx="22" ry="18" fill="rgba(255,255,255,0.14)"
      transform="rotate(-18,112,96)" />
    {/* Neck shadow */}
    <ellipse cx="130" cy="164" rx="28" ry="8" fill="rgba(0,0,0,0.14)" />

    {/* ══ HAIR — long dark brown, flowing 70s rock ══ */}
    {/* Crown */}
    <path d="M 79 104 Q 81 60 130 54 Q 179 60 181 104 Q 168 68 130 64 Q 92 68 79 104 Z"
      fill="#231206" stroke="#160a04" strokeWidth="1.5" />
    {/* Left flowing locks */}
    <path d="M 79 104 Q 68 128 66 160 Q 64 182 68 198 Q 76 176 74 152 Q 76 128 84 112 Z"
      fill="#231206" />
    {/* Right flowing locks */}
    <path d="M 181 104 Q 192 128 194 160 Q 196 182 192 198 Q 184 176 186 152 Q 184 128 176 112 Z"
      fill="#231206" />
    {/* Hair highlight */}
    <path d="M 106 66 Q 130 60 154 68" fill="none" stroke="rgba(110,65,25,0.38)" strokeWidth="5"
      strokeLinecap="round" />
    {/* Sideburns */}
    <path d="M 79 106 Q 74 122 76 138 Q 80 140 84 130 Q 84 118 80 108 Z" fill="#1e0e04" />
    <path d="M 181 106 Q 186 122 184 138 Q 180 140 176 130 Q 176 118 180 108 Z" fill="#1e0e04" />

    {/* ══ EARS ══ */}
    <ellipse cx="78" cy="122" rx="9" ry="13" fill="url(#bz_skin)" stroke="#b07038" strokeWidth="2" />
    <path d="M 80 113 Q 75 122 80 131" fill="none" stroke="#b07038" strokeWidth="1.5" strokeLinecap="round" />
    <ellipse cx="182" cy="122" rx="9" ry="13" fill="url(#bz_skin)" stroke="#b07038" strokeWidth="2" />
    <path d="M 180 113 Q 185 122 180 131" fill="none" stroke="#b07038" strokeWidth="1.5" strokeLinecap="round" />

    {/* ══ EYEBROWS — thick, powerful ══ */}
    <path d="M 95 104 Q 108 96 122 102" fill="none" stroke="#1e0c04" strokeWidth="4.5" strokeLinecap="round" />
    <path d="M 138 102 Q 152 96 165 104" fill="none" stroke="#1e0c04" strokeWidth="4.5" strokeLinecap="round" />

    {/* ══ EYES — intense, focused ══ */}
    <path d="M 95 119 Q 106 111 118 116 Q 119 126 110 127 Q 97 127 95 119 Z"
      fill="white" stroke="#1a1a1a" strokeWidth="1.2" />
    <path d="M 142 119 Q 153 111 165 116 Q 166 126 157 127 Q 144 127 142 119 Z"
      fill="white" stroke="#1a1a1a" strokeWidth="1.2" />
    {/* Irises */}
    <circle cx="107" cy="120" r="6.5" fill="#1e0c06" />
    <circle cx="154" cy="120" r="6.5" fill="#1e0c06" />
    <circle cx="107" cy="120" r="4.5" fill="#0e0604" />
    <circle cx="154" cy="120" r="4.5" fill="#0e0604" />
    {/* Eye shines */}
    <circle cx="109" cy="117" r="2.2" fill="white" />
    <circle cx="156" cy="117" r="2.2" fill="white" />
    <circle cx="106" cy="123" r="1" fill="rgba(255,255,255,0.5)" />
    <circle cx="153" cy="123" r="1" fill="rgba(255,255,255,0.5)" />
    {/* Eyelid lines */}
    <path d="M 95 119 Q 106 113 118 118" fill="none" stroke="#100604" strokeWidth="2" strokeLinecap="round" />
    <path d="M 142 118 Q 153 113 165 119" fill="none" stroke="#100604" strokeWidth="2" strokeLinecap="round" />

    {/* ══ NOSE ══ */}
    <path d="M 130 130 Q 124 140 122 144 Q 130 149 138 144 Q 136 140 130 130" fill="#d49060" />
    <path d="M 122 144 Q 130 149 138 144" fill="none" stroke="#b07038" strokeWidth="2" strokeLinecap="round" />

    {/* ══ MUSTACHE — Bonham's iconic thick 'stache ══ */}
    <path d="M 106 150 Q 118 144 130 146 Q 142 144 154 150 Q 146 160 130 157 Q 114 160 106 150 Z"
      fill="#1e0c04" stroke="#120806" strokeWidth="1" />
    <path d="M 124 145 Q 130 150 136 145" fill="none" stroke="rgba(100,60,30,0.28)" strokeWidth="2"
      strokeLinecap="round" />

    {/* ══ MOUTH — determined grin ══ */}
    <path d="M 116 157 Q 130 167 144 157" fill="none" stroke="#8a4820" strokeWidth="2.5" strokeLinecap="round" />

    {/* Cheek warmth */}
    <ellipse cx="92" cy="134" rx="12" ry="9" fill="rgba(210,110,60,0.16)" />
    <ellipse cx="168" cy="134" rx="12" ry="9" fill="rgba(210,110,60,0.16)" />

    {/* ══ CRASH CYMBAL STAND (right side) ══ */}
    <line x1="218" y1="284" x2="228" y2="324" stroke="#909090" strokeWidth="2.5" strokeLinecap="round" />
    <line x1="210" y1="290" x2="228" y2="290" stroke="#808080" strokeWidth="2" strokeLinecap="round" />
    {/* Cymbal boom arm */}
    <line x1="194" y1="178" x2="220" y2="286" stroke="#a0a0a0" strokeWidth="2.5" strokeLinecap="round" />

    {/* ══ SNARE DRUM (front left) ══ */}
    <ellipse cx="65" cy="274" rx="30" ry="13" fill="url(#bz_chrome)" stroke="#707070" strokeWidth="2.5" />
    <ellipse cx="65" cy="268" rx="25" ry="9.5" fill="url(#bz_drumhead)" stroke="#b8b8b8" strokeWidth="2" />
    {/* Snare wires */}
    <path d="M 35 275 Q 65 280 95 275" fill="none" stroke="rgba(180,180,180,0.7)" strokeWidth="1.2" />
    <path d="M 37 277 Q 65 282 93 277" fill="none" stroke="rgba(180,180,180,0.45)" strokeWidth="0.8" />
    {/* Snare stand */}
    <line x1="52" y1="282" x2="36" y2="322" stroke="#808080" strokeWidth="2.5" strokeLinecap="round" />
    <line x1="78" y1="282" x2="94" y2="322" stroke="#808080" strokeWidth="2.5" strokeLinecap="round" />
    <line x1="65" y1="286" x2="65" y2="322" stroke="#707070" strokeWidth="2" strokeLinecap="round" />

    {/* ══ HI-HAT CYMBALS (left, above stand) ══ */}
    {/* Bottom cymbal */}
    <ellipse cx="20" cy="222" rx="27" ry="6.5" fill="url(#bz_cymbal)" stroke="#a07810" strokeWidth="1.5" />
    {/* Top cymbal (slightly above, closed) */}
    <ellipse cx="20" cy="216" rx="25" ry="5.5" fill="url(#bz_cymbal)" stroke="#a07810" strokeWidth="1.5" />
    {/* Cymbal highlight */}
    <ellipse cx="14" cy="214" rx="10" ry="2.5" fill="rgba(255,240,100,0.4)" />

    {/* ══ CRASH CYMBAL (right, large, tilted) ══ */}
    <ellipse cx="195" cy="172" rx="38" ry="9.5" fill="url(#bz_cymbal)" stroke="#9a7210" strokeWidth="2"
      filter="url(#bz_drop)" transform="rotate(-10,195,172)" />
    {/* Cymbal highlight */}
    <ellipse cx="184" cy="168" rx="20" ry="4" fill="rgba(255,240,100,0.42)"
      transform="rotate(-10,184,168)" />
    {/* Cymbal bell */}
    <ellipse cx="198" cy="172" rx="7" ry="3.5" fill="#d4a820" stroke="#a07810" strokeWidth="1"
      transform="rotate(-10,198,172)" />

    {/* ══ LEFT DRUMSTICK (near hi-hat) ══ */}
    <line x1="28" y1="258" x2="16" y2="222" stroke="#c8922a" strokeWidth="5.5" strokeLinecap="round" />
    <ellipse cx="16" cy="221" rx="4.5" ry="3.5" fill="#b07820" />
    {/* Grip tape hints */}
    <line x1="30" y1="254" x2="24" y2="248" stroke="rgba(100,60,20,0.45)" strokeWidth="1.5" />
    <line x1="27" y1="250" x2="21" y2="244" stroke="rgba(100,60,20,0.45)" strokeWidth="1.5" />

    {/* ══ RIGHT DRUMSTICK (raised HIGH — BONHAM POWER STRIKE) ══ */}
    <line x1="242" y1="118" x2="256" y2="68" stroke="#c8922a" strokeWidth="5.5" strokeLinecap="round" />
    <ellipse cx="257" cy="66" rx="4.5" ry="3.5" fill="#b07820" transform="rotate(-28,257,66)" />
    {/* Motion blur streaks (speed effect) */}
    <line x1="248" y1="105" x2="262" y2="55" stroke="rgba(200,145,42,0.3)" strokeWidth="3"
      strokeLinecap="round" />
    <line x1="244" y1="110" x2="258" y2="60" stroke="rgba(200,145,42,0.2)" strokeWidth="2"
      strokeLinecap="round" />
  </svg>
);

export default BonzoCharacter;
